
import { createApp } from 'vue'
import './style.css'
import './100rem.js'
import App from './App.vue'
import router from './router'
import store from './store'
// import axios from 'axios'

const app = createApp(App)

app.config.productionTip = false

// 将 axios 注入到 Vue 实例的原型链中
// app.config.globalProperties.$axios = axios
// app.config.globalProperties.$API = API
app.use(store)
app.use(router)
app.mount('#app')

